// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // backend_url:"http://135.125.31.221:8080/easylink-api-admin/v1/",
  // backend_url_Adh:"http://135.125.31.221:8080/easylink-api-adherent/v1/",
  // backend_url_Convention:"http://135.125.31.221:8080/easylink-api-convention/v1/",
  // //backend_url:"http://149.202.3.56:8080/administration-easylink-api-1.0.0-SNAPSHOT/v1/",
  // local_backend_url:'http://localhost:8080/v1/',
  // image_url:'http://87.98.167.49/easylink',
  // // backend_url_Ord:"http://localhost:8081/v1/",
  // backend_url_Ord:'http://135.125.31.221:8080/easylink-api-ordering/v1/',
  // backrnd_url_Pro:"http://135.125.31.221:8080/easylink-api-provider/v1/",
  // backend_url_Product:"http://135.125.31.221:8080/easylink-api-product/v1/",
  // backend_url_Provider:"http://135.125.31.221:8080/easylink-api-provider/v1/",
  // backend_url_Eligibility:"http://135.125.31.221:8080/easylink-api-eligibility/v1/eligibility/",
  // backend_url_Comptabilite:"http://135.125.31.221:8080/easylink-api-comptabilite/v1/",
  // backend_url_Css:"http://135.125.31.221:8080/easylink-api-css/v1/",
  // backend_url_Customer: "http://135.125.31.221:8080/easylink-api-customer/v1/",
  // backend_url_Otp:"http://135.125.31.221:8080/easylink-api-otp/v1/",


  backend_url:"https://api1.easylink.tn:8443/easylink-api-admin/v1/",
  backend_url_Adh:"https://api1.easylink.tn:8443/easylink-api-adherent/v1/",
  backend_url_Convention:"https://api1.easylink.tn:8443/easylink-api-convention/v1/",
  //backend_url:"http://149.202.3.56:8080/administration-easylink-api-1.0.0-SNAPSHOT/v1/",
  local_backend_url:'http://localhost:8080/v1/',
  image_url:'https://ged.easylink.tn/easylink/',
  backend_url_Ord:'https://api1.easylink.tn:8443/easylink-api-ordering/v1/',
  backrnd_url_Pro:"https://api1.easylink.tn:8443/easylink-api-provider/v1/",
  backend_url_Product:"https://api1.easylink.tn:8443/easylink-api-product/v1/",
  backend_url_Provider:"https://api1.easylink.tn:8443/easylink-api-provider/v1/",
  backend_url_Eligibility:"https://api1.easylink.tn:8443/easylink-api-eligibility/v1/eligibility/",
  backend_url_Comptabilite:"https://api1.easylink.tn:8443/easylink-api-comptabilite/v1/",
  backend_url_Css:"https://api1.easylink.tn:8443/easylink-api-css/v1/",  
  backend_url_Customer: "https://api1.easylink.tn:8443/easylink-api-customer/v1/",
  backend_url_Otp:"https://api1.easylink.tn:8443/easylink-api-otp/otp/", 



  dialogflow: {
    angularBot: '0cd3c8d273284057a59c7bc305a91dc2'
  }

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
